import { InjectionToken } from "@angular/core";
import { IGroupsOverviewStateService } from "./i-groups-overview-state.service";

export const groupsOverviewStateServiceInjectionToken: InjectionToken<IGroupsOverviewStateService> = new InjectionToken<IGroupsOverviewStateService>("digital-signage.user-dashboard.dashboard-web.GroupsOverviewStateService");
